<template>
    <div class="vuetable-filterbar col-md-12 step-filtrar">
        <div class="form-group">
            <b-container fluid>
                <b-row no-gutters>
                    <b-col sm="6" md="2">
                        <div class="fl-flex-label fl-collapsed fl-background">
                            <input
                                type="text"
                                class="form-control"
                                v-model="cd"
                                @keyup.enter="doFilter"
                            />
                            <label
                                class="fl-label"
                                for="default-input"
                                style="left: 13px; right: 12px"
                            >
                                Código
                            </label>
                        </div>
                    </b-col>

                    <b-col sm="6" md="2">
                        <div class="fl-flex-label fl-collapsed fl-background">
                            <input
                                type="text"
                                class="form-control"
                                v-model="qrcode"
                                @keyup.enter="doFilter"
                            />
                            <label
                                class="fl-label"
                                for="default-input"
                                style="left: 13px; right: 12px"
                            >
                                QRCode
                            </label>
                        </div>
                    </b-col>

                    <b-col sm="6" md="2">
                        <div class="fl-flex-label fl-collapsed fl-background">
                            <input
                                type="text"
                                class="form-control"
                                v-model="capacidade_kg"
                                @keyup.enter="doFilter"
                            />
                            <label
                                class="fl-label"
                                for="default-input"
                                style="left: 13px; right: 12px"
                            >
                                Capacidade Kg
                            </label>
                        </div>
                    </b-col>

                    <b-col sm="6" md="2">
                        <div class="fl-flex-label fl-collapsed fl-background">
                            <input
                                type="text"
                                class="form-control"
                                v-model="capacidade_m3"
                                @keyup.enter="doFilter"
                            />
                            <label
                                class="fl-label"
                                for="default-input"
                                style="left: 13px; right: 12px"
                            >
                                Capacidade m³
                            </label>
                        </div>
                    </b-col>

                    <b-col sm="6" md="2">
                        <multiselect
                            v-model="status"
                            :options="optionsStatus"
                            track-by="value"
                            label="label"
                            :hide-selected="true"
                            id="status"
                            placeholder="Status"
                            tag-placeholder="Selecionar"
                            select-label="Selecionar"
                            selected-label="Selecionado"
                            deselect-label="Remover"
                        ></multiselect>
                    </b-col>

                    <b-col sm="6" md="2">
                        <div class="d-flex flex-row-reverse">
                            <div class="input-group-btn">
                                <div class="btn-group">
                                    <button
                                        type="button"
                                        class="btn btn-secondary btn-outline"
                                        @click="doFilter"
                                        :disabled="vuetableFilterButton"
                                    >
                                        Filtrar
                                    </button>
                                    <button
                                        type="button"
                                        class="btn btn-secondary btn-outline"
                                        @click="resetFilter"
                                        :disabled="vuetableFilterButton"
                                    >
                                        Limpar
                                    </button>
                                </div>
                            </div>
                        </div>
                    </b-col>
                </b-row>
            </b-container>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            date_attributes: [
                { key: "today", highlight: true, dates: new Date() },
            ],
            cd: "",
            qrcode: "",
            capacidade_kg: "",
            capacidade_m3: "",
            status: null,
            optionsStatus: [],
            data_filter: {},
            helpForm: new Form({}),
        };
    },
    mounted() {
        this.$events.$on("filter-reset", (e) => this.onFilterReset());
        this.popularFiltros();
    },
    methods: {
        doFilter() {
            this.$store.commit("setVuetableFilterButton", true);
            const status = this.status ? this.status.value : null;

            this.data_filter = {
                cd: this.cd,
                qrcode: this.qrcode,
                capacidade_kg: this.capacidade_kg,
                capacidade_m3: this.capacidade_m3,
                status,
            };
            this.$events.fire("filter-set", this.data_filter);
        },
        onFilterReset() {
            this.cd = "";
            this.qrcode = "";
            this.capacidade_kg = "";
            this.capacidade_m3 = "";
            this.status = null;
            this.doFilter();
        },
        resetFilter() {
            this.onFilterReset();
        },
        popularFiltros() {
            this.helpForm
                .get("/api/pallet/jsonlistfilters")
                .then((response) => {
                    new ReturnApi(response, this, true, false, false);
                    response.status.forEach((obj) => {
                        this.optionsStatus.push({
                            label: obj.descr,
                            value: obj.valor,
                        });
                    });
                })
                .catch((errors) => {
                    new ReturnApi(errors, this);
                });
        },
    },
    computed: {
        vuetableFilterButton: {
            get() {
                return this.$store.state.vuetable.filterButton;
            },
        },
    },
};
</script>
